import * as pdfjsLib from "pdfjs-dist";

import pdfWorkerUrl from "pdfjs-dist/build/pdf.worker.min.js?url";

type PdfDocumentSource = string | ArrayBuffer | ArrayBufferView;
type PdfDocumentOptions = Record<string, unknown>;

interface PdfJsLibrary {
  getDocument: (source: Record<string, unknown>) => PdfLoadingTask;
  GlobalWorkerOptions?: {
    workerSrc?: string;
  };
  PDFJS?: {
    isEvalSupported?: boolean;
    workerSrc?: string | null;
  };
}

interface PdfLoadingTask<TDocument = unknown> {
  promise: Promise<TDocument>;
}

let configured = false;

export function getPdfJs() {
  if (!configured) {
    const pdfjs = pdfjsLib as PdfJsLibrary;

    if (pdfjs.GlobalWorkerOptions) {
      pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;
    }

    if (pdfjs.PDFJS) {
      pdfjs.PDFJS.workerSrc = pdfWorkerUrl;
      pdfjs.PDFJS.isEvalSupported = false;
    }

    configured = true;
  }

  return pdfjsLib as PdfJsLibrary;
}

export function createPdfDocument<TDocument = unknown>(
  source: PdfDocumentSource,
  options: PdfDocumentOptions = {}
): PdfLoadingTask<TDocument> {
  const isBinarySource =
    source instanceof ArrayBuffer ||
    (ArrayBuffer.isView(source) && source.buffer instanceof ArrayBuffer);

  return getPdfJs().getDocument({
    ...(isBinarySource ? { data: source } : { url: source }),
    isEvalSupported: false,
    ...options,
  }) as PdfLoadingTask<TDocument>;
}
